import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=52af191d&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformation.vue?vue&type=style&index=0&id=52af191d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af191d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52af191d')) {
      api.createRecord('52af191d', component.options)
    } else {
      api.reload('52af191d', component.options)
    }
    module.hot.accept("./GeneralInformation.vue?vue&type=template&id=52af191d&scoped=true", function () {
      api.rerender('52af191d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/serviceLocation/GeneralInformation.vue"
export default component.exports